/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import GoogleMapAppointments from 'DesignSystem/GoogleMapAppointments/react'
import LocationChoice from 'DesignSystem/LocationChoice/index'
import React from 'react'
import ViewsStream from 'Simple/Stream/react-dom'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Location({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Location",
  focusArea,
  choices,
  onMouseEnter,
  onMouseLeave,
  setHighlightedLocation,
  onSelect,
  selected,
  dentalPlan,
  appointmentTypes,
  selectedLocationVisitType,
  highlightedLocation,
  listElementRef,
  center,
  maps,
  hoveredMarker,
  markers,
  userLocation
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtLocationchoiceColorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.color.brand.base'
        })
let dtLocationchoiceBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.borderColor.brand.base'
        })
let dtLocationchoiceBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.backgroundColor.brand.hovered'
        })
let dtLocationchoiceBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.borderColor.brand.hovered'
        })
let dtLocationchoiceColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.color.brand.hovered'
        })
let dtLocationchoiceBackgroundcolorBrandHighlighted = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.backgroundColor.brand.highlighted'
        })
let dtLocationchoiceBordercolorBrandHighlighted = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.borderColor.brand.highlighted'
        })
let dtLocationchoiceColorBrandHighlighted = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.color.brand.highlighted'
        })
let dtLocationchoiceBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.backgroundColor.brand.selected'
        })
let dtLocationchoiceBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.borderColor.brand.selected'
        })
let dtLocationchoiceColorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'LocationChoice.color.brand.selected'
        })
let dtButtonvisitchoiceBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.backgroundColor.brand.hovered'
        })
let dtButtonvisitchoiceBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.backgroundColor.brand.selected'
        })
let dtButtonvisitchoiceBordercolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.borderColor.brand.base'
        })
let dtButtonvisitchoiceBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.borderColor.brand.hovered'
        })
let dtButtonvisitchoiceBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.borderColor.brand.selected'
        })
let dtButtonvisitchoiceColorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.color.brand.base'
        })
let dtButtonvisitchoiceColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.color.brand.hovered'
        })
let dtButtonvisitchoiceColorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ButtonVisitChoice.color.brand.selected'
        })
  return (<React.Fragment
>
<div
  data-testid="Location.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Location.Vertical:1"
  data-view-path={viewPath}
 ref={focusArea}
 style={{'--o-1-2jX8FA': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Location.Horizontal"
  data-view-path={viewPath}
 style={{'--fd-2-2jX8FA': isMedia.mobile ? "column" : "row"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Location.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Location.List"
  data-view-path={viewPath}
 key="item.id"
 style={{'--pb-4-2jX8FA': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-3-2jX8FA': isMedia.mobile ? "140px" : "500px",'--fd-2-2jX8FA': isMedia.mobile ? "row" : "column",'--ox-5-2jX8FA': isMedia.mobile ? "auto" : "hidden",'--oy-6-2jX8FA': isMedia.mobile ? "hidden" : "auto",'--mt-7-2jX8FA': isMedia.mobile ? typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs : "0px",'--mr-8-2jX8FA': isMedia.mobile ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
<ViewsStream
>
{Array.isArray(choices) && choices.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="choice"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/LocationChoice(${item?.id ?? item?._id ?? index})`}
      >
<LocationChoice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/LocationChoice(${item?.id ?? item?._id ?? index})`}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onClick={setHighlightedLocation}
 onSelect={onSelect}
 selected={selected}
 dentalPlan={dentalPlan}
 appointmentTypes={appointmentTypes}
 selectedLocationVisitType={selectedLocationVisitType}
 highlightedLocation={highlightedLocation}
 innerRef={listElementRef}
 color={dtLocationchoiceColorBrandBase}
 borderColor={dtLocationchoiceBordercolorBrandBase}
 backgroundColorHovered={dtLocationchoiceBackgroundcolorBrandHovered}
 borderColorHovered={dtLocationchoiceBordercolorBrandHovered}
 colorHovered={dtLocationchoiceColorBrandHovered}
 backgroundColorHighlighted={dtLocationchoiceBackgroundcolorBrandHighlighted}
 borderColorHighlighted={dtLocationchoiceBordercolorBrandHighlighted}
 colorHighlighted={dtLocationchoiceColorBrandHighlighted}
 backgroundColorSelected={dtLocationchoiceBackgroundcolorBrandSelected}
 borderColorSelected={dtLocationchoiceBordercolorBrandSelected}
 colorSelected={dtLocationchoiceColorBrandSelected}
 buttonBackgroundColorHovered={dtButtonvisitchoiceBackgroundcolorBrandHovered}
 buttonBackgroundColorSelected={dtButtonvisitchoiceBackgroundcolorBrandSelected}
 buttonBorderColor={dtButtonvisitchoiceBordercolorBrandBase}
 buttonBorderColorHovered={dtButtonvisitchoiceBordercolorBrandHovered}
 buttonBorderColorSelected={dtButtonvisitchoiceBordercolorBrandSelected}
 buttonColor={dtButtonvisitchoiceColorBrandBase}
 buttonColorHovered={dtButtonvisitchoiceColorBrandHovered}
 buttonColorSelected={dtButtonvisitchoiceColorBrandSelected}
/>
</ListItem>
)}
</ViewsStream>
</div>
</div>
<GoogleMapAppointments
  viewPath={`${viewPath}/GoogleMapAppointments`}
 center={center}
 maps={maps}
 height={isMedia.mobile ? "300px" : "500px"}
 highlightedLocation={highlightedLocation}
 hoveredMarker={hoveredMarker}
 markers={markers}
 setHighlightedLocation={setHighlightedLocation}
 userLocation={userLocation}
 width="100%"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }